<template>
  <div class="list">
    <div
      class="list__header"
      :class="{ 'list__header--expandable': isExpandable }"
      @click="handleExpand"
    >
      <span>
        {{ title }}
      </span>
      <span v-if="isExpandable">
        <v-icon> {{ expandIcon }} </v-icon>
      </span>
    </div>
    <div v-show="isExpanded" class="list__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorFaqList",
  props: {
    title: {
      type: String,
      required: true
    },
    isExpandable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExpanded: true
    };
  },
  computed: {
    expandIcon() {
      return this.isExpanded ? "mdi-chevron-up" : "mdi-chevron-down";
    }
  },
  methods: {
    handleExpand() {
      if (!this.isExpandable) return;
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: $spacing * 2;

  &__header {
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &--expandable {
      cursor: pointer;
      border: 1px solid $lime;
      padding: $spacing * 2.5;
      height: 46px;

      &:hover {
        background: $gray-100;
        border: 1px solid darken($lime, 5%);
      }
    }

    span {
      @include font-size(14px);
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: $spacing * 2;
  }
}
</style>
